"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M8 4v.89l2 2V4h4v4h-2.89l2 2H14v.89l2 2V10h4v4h-2.89l2 2H20v.89l2 2V4c0-1.1-.9-2-2-2H5.11l2 2zm8 0h3c.55 0 1 .45 1 1v3h-4zm6.16 17.88L2.12 1.84a.996.996 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L2 4.55V20c0 1.1.9 2 2 2h15.45l1.3 1.3c.39.39 1.02.39 1.41 0s.39-1.03 0-1.42M10 12.55 11.45 14H10zm-6-6L5.45 8H4zM8 20H5c-.55 0-1-.45-1-1v-3h4zm0-6H4v-4h3.45l.55.55zm6 6h-4v-4h3.45l.55.55zm2 0v-1.45L17.45 20z"
}), 'GridOffRounded');